import { writable } from 'svelte/store';
import MdIntegrationsModal from './md-integrations-modal.svelte';
import uniappModalSvelte from './uniapp-modal.svelte';
import wellabeModalSvelte from './wellabe-modal.svelte';
import FprjModal from './fprj-modal.svelte';
import MailFormModal from './contact-form-modal.svelte';
export const modalComponent = writable(null);
export const modalKeys = [
    { app: 'uniapp', component: uniappModalSvelte },
    { app: 'md-integrations', component: MdIntegrationsModal },
    { app: 'wellabe', component: wellabeModalSvelte },
    { app: 'fprj', component: FprjModal },
    { app: 'contact-form', component: MailFormModal },
];
export function setModalHash(param) {
    if (param !== 'uniapp' &&
        param !== 'wellabe' &&
        param !== 'md-integrations' &&
        param !== 'fprj' &&
        param !== 'contact-form') {
        return;
    }
    window.location.hash = param;
    const currentModal = modalKeys.find((item) => {
        return item.app === param;
    });
    modalComponent.set({ app: currentModal.app, component: currentModal.component });
}
